import {React} from 'react'
import {motion} from 'framer-motion'
import {Col} from 'react-bootstrap'
import { Link } from 'react-router-dom'

import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { cartActions } from '../../redux/slices/cartSlice'
import '../../assets/style/productCard.css'



const ProductCard = ({item}) => {

    const dispatch = useDispatch()
    const addToCart = ()=>{
        dispatch(cartActions.addItem({
            id:item.id,
            productName:item.productName,
            price:item.price,
            imgUrl:item.imgUrl
            })
        )
        toast.success('Product Added TO the Cart')
    }



    return (
        <>
            <Col lg='3' md='4' className='mb-2'>
                <div className="product__card">
                    <div className="product__img">
                        <Link to={`/shop/${item.id}`}><motion.img whileHover={{scale:0.9}} src={item.imgUrl} alt="product" /></Link>
                    </div>
                    
                    <div className='product__info p-2'>
                        <h3 className="product__name"><Link to={`/shop/${item.id}`}>{item.productName}</Link></h3>
                        <span>{item.category}</span>
                    </div>
                    
                    <div className='product__card-bottom p-2 d-flex align-items-center justify-content-between'>
                        <span className="price">${item.price}</span>
                        <motion.span onClick={addToCart} whileTap={{scale:1.2}}><i className='ri-add-line'></i></motion.span>
                    </div>
                </div>
            </Col>
        </>
    )
}

export default ProductCard